/*eslint-disable*/
import { useEffect } from "react";
import ChallengeCompleted from "./ChallengeCompleted";
import ChallengeOngoing from "./ChallengeOngoing";
import Navigate from "../../shared/navigation/navigate";
import { store } from "../../shared/store";
import Loader from "../../shared/components/loaders/Loader";
import { useChallenge } from "./ChallengeContext";

const Challenge = () => {
  const {
    challengeInfo,
    isLoading,
    selectedStatus,
    selectedFilters,
    perPage,
    setPerPage,
    page,
    getData,
    handleResize,
    setPreview,
  } = useChallenge();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has("per_page")) {
      setPerPage(params.get("per_page"));
    }

    if (params.has("preview")) {
      setPreview(params.get("preview"));
    }

    try {
      const state = store.getState();
      const isGolferActive =
        state.profileReducer.golferProfileFetchReducer.golferActive;
      if (!isGolferActive) {
        Navigate.toPath("/profile");
        return;
      }
    } catch (err) {
      console.error("Error checking golfer status", err);
      Navigate.toPath("/error", {
        state: { error: err.message || "Error checking golfer status" },
      });
      return;
    }

    getData();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [selectedStatus, selectedFilters, page, perPage]);

  if (isLoading) return <Loader />;

  if (challengeInfo?.status === "completed") {
    return <ChallengeCompleted />;
  } else {
    return <ChallengeOngoing />;
  }
};

export default Challenge;
